<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>

<div *ngIf="signers.length>0 else loading">
    <h3>{{ 'DOCUMENTS.TEXT.SIGNERS' | translate }}</h3>
    <ul class="singers-list">
        <li *ngFor="let s of signers; let i = index"
            [attr.data-index]="i"
        >
        <app-contract-avatar  [avatarSize]="'36px'" [userGuid]="s.user.guid"  [checkedState]="s.sign"> </app-contract-avatar>
            <div class="signers-item" (click)="helper.openProfileByGuid(s.user.guid)" data-action="openProfile">
                <span [class.blocked_user]="s.user.project_setting.observation_type === 'blocked'"
                      [class.inactive_user]="!s.user.is_active" >
                    {{ helper.fullName(s.user) }}
                </span>
            </div>
              <button (click)="deleteSigner(s)" data-action="deleteSigner" 
                [disabled]=" !editPermission || s.sign || fileModel.is_approved"
                class="button-icon icononly size-l secondary-button"
                  matTooltip="{{ 'DOCUMENTS.BUTTONS.DELETE_SIGNER' | translate }}" >
                  <mat-icon svgIcon="delete-bin-fill"> </mat-icon>
                </button>
        </li>
    </ul>
    <button class="button-icon size-l primary-button" data-action="addSigner" style="margin-top: 12px; margin-bottom: 12px;"
       *ngIf="editPermission && !fileModel.signed && currentMember && currentMember.project_setting.is_project_admin"
      [disabled]="fileModel.is_approved"
      (click)="openDialog(addSignersView,500,200)">
      <mat-icon svgIcon="ball-pen-fill"></mat-icon>
      <span>  {{ 'DOCUMENTS.BUTTONS.ADD_SIGNER' | translate }}   </span>
    </button>
</div>

<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>


<ng-template #addSignersView let-modal>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.ADD_SIGNER' | translate }}</h2>

        <select #member class="form-select">
            <option hidden selected value="">{{ 'MODALS.FIELDS.SELECT.SIGNER' | translate }}</option>
            <option *ngFor="let member of allMembers"
                    [class.inactive_user]="!member.is_active"
                    [value]="member.guid"
            >
                {{member.computed_name }}
            </option>
        </select>
        <button (click)="addSigner(member)" data-action="addSignerButton"   [disabled]="isLockButton"
          class="button-icon size-xl primary-button" style="margin-top: 13px;">
          <mat-icon svgIcon="user-add-fill"> </mat-icon>
          <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button>
    </div>
</ng-template>
